import { render, staticRenderFns } from "./afsluit.vue?vue&type=template&id=311a12f6"
import script from "./afsluit.vue?vue&type=script&lang=js"
export * from "./afsluit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports